import {BrowserRouter, createRoot, ToastContainer} from 'external/react'

import App from './App'

const $root = document.getElementById('root')
if ($root) {
	const root = createRoot($root)
	root.render(<BrowserRouter>
		<ToastContainer position='bottom-right' autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
		<App />
	</BrowserRouter>)
}